import Dialog from '@pelckmans/elementis/components/dialog';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ListSkeleton from '../../../../shared-components/ListSkeleton';

export default function EmptyState() {
  const { t } = useTranslation();

  useEffect(() => {
    // Scroll container is the main element in the page layout
    const mainElement = document.querySelector('main');
    if (!mainElement) return;
    mainElement.classList.add('main__fixed');

    return () => {
      mainElement.classList.remove('main__fixed');
    };
  }, []);

  return (
    <>
      <div className="no-material-dialog">
        <Dialog
          id="empty-state-dialog"
          size="sm"
          className="empty-state-dialog"
          aria-label={t('PAGES.CATEGORICAL.EMPTY.A11Y_LABEL')}
          data-testid="empty-state"
        >
          <Dialog.Header title={t('PAGES.CATEGORICAL.EMPTY.TITLE')} />
          <Dialog.Body>{t('PAGES.CATEGORICAL.EMPTY.BODY')}</Dialog.Body>
        </Dialog>
      </div>
      <ListSkeleton size={12} height={80} isLoading={false} />
    </>
  );
}
